import { MOKA_SERVICE_HOST } from 'api/constants';

export const CUSTOMERS = `${MOKA_SERVICE_HOST}/customer/v1/customers`;
export function CUSTOMER_DETAIL(customerId) {
  return `${MOKA_SERVICE_HOST}/customer/v1/customers/${customerId}`;
}
export const CUSTOMERS_EXPORT = `${MOKA_SERVICE_HOST}/customer/v1/customers/export`;
export const REDEMPTION_HISTORIES = customerId =>
  `${MOKA_SERVICE_HOST}/loyalty/v1/customers/${customerId}/redemptions`;
export const POINT_ACTIVITIES = customerId =>
  `${MOKA_SERVICE_HOST}/loyalty/v1/customers/${customerId}/point-activities`;

export function CUSTOMER_PAYMENTS(customerId) {
  return `${MOKA_SERVICE_HOST}/customer/v1/customers/${customerId}/payments`;
}
